// extracted by mini-css-extract-plugin
module.exports = {"container":"Social-module--container--2nwqS"};